import React from "react";
import dynamic from "next/dynamic";

const ReactApexChart = dynamic(() => import("react-apexcharts"), {
  ssr: false,
});

const DashboardProjectTreeMap: React.FC = (alldashboardDataList: any) => {
  // Treemap Chart options

  const treemapData =
    alldashboardDataList?.alldashboardDataList?.top_req_services?.map(
      (service: any) => ({
        x: service._id,
        y: service.count,
      })
    );

  

  const options = {
    series: [
      {
        data: treemapData,
      },
    ],
    legend: {
      show: false,
    },

    chart: {
      height: 350,
      type: "treemap",
      toolbar: {
        show: false,
        tools: {
          zoomin: false,
          zoomout: false,
          zoom: false,
          pan: false,
          reset: false,
          //download: '<img src="/assets/images/down-arrow.svg" width="20">',
        },
      },
    },
    title: {
      text: "Top Requested Services",
    },

    noData: {
      text: "No data found",
      align: "center",
      verticalAlign: "middle",
    },
    plotOptions: {
      treemap: {
        distributed: true,
        enableShades: false,
      },
    },
    colors: [
      "#3159fe72",
      "#7695a1b5",
      "#ee243d8e",
      "#f4ab2199",
      "#CDD7B6",
      "#C1F666",
      "#D43F97",
      "#1E5D8C",
      "#421243",
      "#7F94B0",
      "#EF6537",
      "#C0ADDB",
    ],
  };

  return (
    <div>
      <ReactApexChart
        options={options}
        series={options.series}
        type="treemap"
        height={350}
      />
    </div>
  );
};

export default DashboardProjectTreeMap;
